import { Status } from 'components';

import { offerStore } from '../store';

export const TitleExtraNode = () => {
  const status = offerStore((state) => state.status);

  return <Status status={status} />;
};
